<template>
    <div>
        <table class="table table-sm table-no-side-paddings table-striped">
            <thead>
                <tr>
                    <Ordering @change="loadUsers" v-model="order" field="name" tag="th">
                        {{ $t('users.name') }}
                    </Ordering>
                    <Ordering @change="loadUsers" v-model="order" field="email" tag="th">
                        {{ $t('users.email') }}
                    </Ordering>
                    <th>
                        {{ $t('users.role') }}
                    </th>
                    <th />
                </tr>
            </thead>

            <tbody v-if="users?.data?.length">
                <tr v-for="user in users.data" :key="user.id">
                    <td>{{ user.name }}</td>
                    <td>{{ user.email }}</td>
                    <td>{{ translateRoles(user.roles).join(', ') }}</td>
                    <td class="text-right">
                        <button v-if="hasPermission('editUser') || hasPermission('adminEditUser')"
                                class="btn btn-xs rounded-pill btn-primary"
                                @click="userToEdit = user"
                                :v-tooltip="$t('general.edit')">
                            <icon name="pencil-alt" scale="0.8"></icon>
                        </button>

                        <button v-if="(hasPermission('deleteUser') || hasPermission('adminDeleteUser')) && store.state.user.id !== user.id"
                                class="btn btn-xs rounded-pill btn-danger"
                                @click="userToDelete = user"
                                :v-tooltip="$t('general.delete')">
                            <icon name="trash" scale="0.8"></icon>
                        </button>
                    </td>
                </tr>
            </tbody>

            <tbody v-if="!isLoading && !users?.data?.length">
                <tr>
                    <td colspan="100%">
                        {{ $t('users.no_users_found') }}
                    </td>
                </tr>
            </tbody>
        </table>

        <Pagination v-if="users" :pagination="users" @change="loadUsers" />

        <EditUserModal v-if="userToEdit" @updated="loadUsers(); userToEdit = null" :user="userToEdit" @close="userToEdit = null" />
        <DeleteUserModal v-if="userToDelete" @deleted="loadUsers(); userToDelete = null" :user="userToDelete" @close="userToDelete = null" />
    </div>
</template>

<script setup>

    import { inject, onMounted, ref } from 'vue';
    import Ordering from '../Ordering.vue';
    import { notifyError } from '../../utils/notify';
    import { UserService } from '../../services/userService';
    import { translateRoles } from '../../utils/auth';
    import Pagination from '../Pagination.vue';
    import EditUserModal from './EditUserModal.vue';
    import DeleteUserModal from './DeleteUserModal.vue';

    const store = inject('store');

    const hasPermission = store.getters.hasPermission;

    const isLoading = ref(false);
    const order = ref('name,desc');
    const users = ref(null);

    const userToDelete = ref(null);
    const userToEdit = ref(null);

    onMounted(() => {
        loadUsers();
    });

    async function loadUsers(page = undefined) {
        isLoading.value = true;

        try {
            const response = await UserService.getInstance().paginateUsers(page || users.value?.current_page || 1, order.value);
            users.value = response.data;
        } catch (exception) {
            notifyError(exception);
        } finally {
            isLoading.value = false;
        }
    }
</script>
